"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/createClass.js"));
var _axios = _interopRequireDefault(require("axios"));
var _vue = _interopRequireDefault(require("vue"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
var _auth = require("./auth");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var HttpRequest = /*#__PURE__*/function () {
  function HttpRequest() {
    var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : baseURL;
    (0, _classCallCheck2.default)(this, HttpRequest);
    this.baseUrl = baseUrl;
  }
  return (0, _createClass2.default)(HttpRequest, [{
    key: "getInsideConfig",
    value: function getInsideConfig() {
      var config = {
        baseURL: this.baseUrl,
        headers: {}
      };
      return config;
    }
  }, {
    key: "interceptors",
    value: function interceptors(instance, url) {
      // 请求拦截
      // Axios 请求拦截器按注册顺序的逆序执行，先注册清理逻辑，确保无 Token 时
      // 能移除后续拦截器写入的 "Bearer undefined"。
      instance.interceptors.request.use(function (config) {
        config.headers = config.headers || {};
        var token = (0, _auth.getToken)();
        if (config.headers.isToken === false || !token) {
          delete config.headers['Authorization'];
        }
        delete config.headers.isToken;
        return config;
      }, function (error) {
        return Promise.reject(error);
      });
      instance.interceptors.request.use(function (config) {
        _nprogress.default.start();
        var token = (0, _auth.getToken)();
        if (token && config.headers.isToken !== false) {
          config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
      }, function (error) {
        console.log(error); // for debug
        return Promise.reject(error);
      });
      // 响应拦截
      instance.interceptors.response.use(function (response) {
        _nprogress.default.done();
        var res = response.data;
        var code = res.code || 200;
        console.log('res---', code, res);
        var resType = response.request.responseType;
        if (resType === 'blob') {
          return response;
        } else if (code === 10086) {
          return Promise.reject(res);
          // Message({
          //   message:res.msg || 'Error',
          //   type: 'error',
          //   duration: 5 * 1000
          // })
          // Vue.prototype.scId = res.data;
          // Vue.prototype.reason = res.msg;
          // return Promise.reject(new Error(res.msg || 'Error'))
        } else if (code !== 200) {
          if (res.status == 200) {
            if (res.data.code != 1) {
              (0, _elementUi.Message)({
                message: res.data.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
              });
              return Promise.reject(new Error(res.msg || 'Error'));
            } else {
              return res;
            }
          }
          if (res.msg) {
            (0, _elementUi.Message)({
              message: res.msg || 'Error',
              type: 'error',
              duration: 5 * 1000
            });
          }
          return Promise.reject(new Error(res.msg || 'Error'));
        } else {
          return res;
        }
      }, function (error) {
        if (error.response && error.response.status === 401) {
          _store.default.dispatch('user/resetToken');
          error.message = '登录已过期，请重新登录';
        }
        (0, _elementUi.Message)({
          message: error.message,
          type: 'error',
          duration: 5 * 1000
        });
        return Promise.reject(error);
      });
    }
  }, {
    key: "request",
    value: function request(options) {
      var instance = _axios.default.create();
      options = Object.assign(this.getInsideConfig(), options);
      this.interceptors(instance, options.url);
      return instance(options);
    }
  }]);
}();
var _default = exports.default = HttpRequest;